import { render, staticRenderFns } from "./vimeo.vue?vue&type=template&id=08b8602a&"
import script from "./vimeo.vue?vue&type=script&lang=js&"
export * from "./vimeo.vue?vue&type=script&lang=js&"
import style0 from "./vimeo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports